export default __webpack_public_path__ + "static/media/shape_top.a6eafa15.webp";